/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'meh': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<g _fill="#7d7d7d"><path pid="0" d="M44.9 35c-.9 8.2-8.3 14.2-16.6 13.2-7-.8-12.5-6.3-13.2-13.2h29.8zM21.7 18.3c1.8 0 3.3 1.5 3.3 3.3V25c0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3v-3.3c-.1-1.9 1.4-3.4 3.3-3.4zM38.3 18.3c1.8 0 3.3 1.5 3.3 3.3V25c0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3v-3.3c0-1.9 1.5-3.4 3.3-3.4z"/><path pid="1" d="M30 60C13.5 60 0 46.5 0 30S13.5 0 30 0s30 13.5 30 30-13.5 30-30 30zm0-56.7C15.3 3.3 3.3 15.3 3.3 30s12 26.7 26.7 26.7 26.7-12 26.7-26.7S44.7 3.3 30 3.3z"/></g>'
  }
})
